<template>
  <div class="page-articles tier tier-two">
    <div class="builder-tip">Here is a list of blog articles on your website, you can add as many as you need</div>

    <div class="site-articles">
      <section v-if="hasArticle">
        <table-data
          :rows="articles"
          @rowClick="changeArticlePage"
          :headings="[{heading: '', key: 'edit'}]"
          class="articles-list">

          <div
            v-for="(article, index) in articles"
            :slot="'td-' + index + '-edit'"
            class="blog-article"
            :key="index">
            <div class="article-item">
              <h2 class="article-number">#{{articleCount[index]}}</h2>
              <span>
                {{ article.heading }}
              </span>
            </div>
          </div>
        </table-data>

        <router-link
          :to="{
            name: 'add-article',
            params: {companyId: companyId, siteId: siteId}
          }"
          class="add-article-link">
          Add Article
        </router-link>

        <pagination @changePage="changePage" :pagination="pageData"></pagination>
      </section>

      <section class="tier-content" v-if="!hasArticle">
        <div class="helper-text no-items">
          <p>You haven't published any articles yet.</p>
          <p>
            <router-link
              :to="{
                name: 'add-article',
                params: {companyId: companyId, siteId: siteId}
              }">
              Write your first article
            </router-link>
          </p>
        </div>
      </section>

      <transition name="column-left">
        <router-view @updatePage="updatePage"/>
      </transition>
    </div>
  </div>
</template>

<script>
import page from '@/mixins/page'
import pagination from '@/mixins/pagination'
import confirm from '@/mixins/confirm'

import {readCompanySiteData} from '@/lib/sites'
import {readCompanySiteArticlesData} from '@/lib/articles'

import Table from '@/components/Table'

export default {
  name: 'Articles',

  mixins: [page, pagination, confirm],

  props: {
    companyId: {
      type: String,
      required: true
    },

    siteId: {
      type: String,
      required: true
    }
  },

  components: {
    TableData: Table
  },

  data() {
    return {
      site: {},
      articles: [],
      sitePage: {}
    }
  },

  methods: {
    getData() {
      readCompanySiteData(this.companyId, this.siteId).then(({data}) => {
        this.site = data
      })

      readCompanySiteArticlesData(this.companyId, this.siteId, this.pagination).then(
        ({data, page}) => {
          this.articles = data
          this.pageData = page
        }
      )
    },

    updatePage(notification) {
      this.$emit('updatePage', notification)
    },

    changeArticlePage(article) {
      this.$router.push({name: 'article', params: {articleId: article.id}})
      this.$emit('changeArticle', article.path)
    }
  },

  computed: {
    title() {
      return this.site.name
    },

    hasArticle() {
      return !!this.articles.length
    },

    articleCount() {
      const count = this.hasArticle ? this.articles.length : false
      let array = []

      for (var i = 0; i < count; i++) {
        array.push(i + 1)
      }

      return array.reverse()
    }
  },

  mounted() {
    this.getData()
  },

  watch: {
    $route() {
      this.getData()
    }
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/base/theme'
@import '../stylesheets/helpers/mixins'
@import '../stylesheets/helpers/extends'

.site-articles
  .table
    box-shadow: none

  .add-article-link
    padding: $gap-medium
    border-top: 1px solid $color-border-light
    width: 100%
    text-align: center
    display: block
    text-transform: uppercase

    @include themify($themes)
      color: themed('color-secondary')

.page-articles
  box-shadow: inset -30px 0px 30px 0px rgba(0, 0, 0, 0.05)

.article-item
  display: flex
  align-items: center

  .article-number
    margin-right: $gap-small

    @include themify($themes)
      color: themed('color-secondary')
</style>
